export function scrollTo(pos) {
  const app = document.getElementById('app');
  if (app) {
    app.scrollTop = pos;
  }
}
export function resetScrollPos() {
  const app = document.getElementById('app');
  if (app) {
    app.scrollTop = 0;
    app.scrollLeft = 0;
  }
}
export const resetScrollById = (id, offsetTop) => {
  const appElement = document.getElementById('app');
  if (!appElement) {
    return;
  }
  const targetElement = document.getElementById(id);
  if (targetElement) {
    appElement.scrollTo({
      top: targetElement.offsetTop + (offsetTop !== null && offsetTop !== void 0 ? offsetTop : 0),
      behavior: 'smooth'
    });
  }
};
export const resetScrollByIdWithAnimation = function (id, offsetTop) {
  let duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;
  const appElement = document.getElementById('app');
  const targetElement = document.getElementById(id);
  if (!appElement || !targetElement) return;
  const start = appElement.scrollTop;
  const end = targetElement.offsetTop + (offsetTop !== null && offsetTop !== void 0 ? offsetTop : 0);
  const distance = end - start;
  const startTime = performance.now();
  const easeInOutQuad = t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  const animate = currentTime => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const easedProgress = easeInOutQuad(progress);
    appElement.scrollTop = start + distance * easedProgress;
    if (progress < 1) {
      requestAnimationFrame(animate);
    }
  };
  requestAnimationFrame(animate);
};